module.exports = __webpack_public_path__ + "img/cargo-container-ship.83594742.jpg";